export default "__VITE_ASSET__DiM3Lj6K__"